import { useImagePlacement } from "../../hooks/useImagePlacement";

export const Contact = () => {
  const { imageUrls, isLoading, error, placements } = useImagePlacement(4, {
    width: 150,
    height: 150,
    quality: 80,
  });

  if (error) {
    console.error("Error loading contact icons:", error);
  }

  return (
    <section id="contact" className="py-6">
      <div className="container mx-auto px-4">
        <div className="flex justify-center items-center flex-wrap gap-x-4 gap-y-1 max-w-[800px] mx-auto">
          {isLoading ? (
            <div>Loading...</div>
          ) : (
            imageUrls.map((url, index) => (
              <a
                key={placements[index].id}
                href={placements[index].additional_config?.link}
                target="_blank"
                rel="noopener noreferrer"
                className="transition-transform hover:scale-110"
              >
                <img
                  src={url}
                  alt={placements[index].illustration.title}
                  className="w-24 h-24 sm:w-28 sm:h-28 lg:w-36 lg:h-36 object-contain"
                />
              </a>
            ))
          )}
        </div>
      </div>
    </section>
  );
};
